import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { Country } from 'src/app/general/services/localization.service';
import { DeviceService } from '../../../general/services/device.service';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { HeadingComponent } from 'src/app/general/components/heading/heading.component';

interface PriceEntry {
  range: string;
  serviceFee: string;
}

@Component({
  selector: 'app-waiter-now-pricing',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    MatCardModule,
    MatTableModule,
    HeadingComponent
  ],
  templateUrl: './waiter-now-pricing.component.html',
  styleUrls: ['./waiter-now-pricing.component.css']
})
export class WaiterNowPricingComponent {
  @Input() country!: Country;

  pricesColumnNames: string[] = ['range', 'serviceFee'];
  pricesUs: PriceEntry[] = [
    /*
    {range:'Subtotal < $20', serviceFee:'$0.25'},
    {range:'$20 ≤ Subtotal < $75', serviceFee:'$0.75'},
    {range:'$75 ≤ Subtotal', serviceFee:'$1'}
    */
    {range:'Subtotal < $10', serviceFee:'$0.50'},
    {range:'$10 ≤ Subtotal < $25', serviceFee:'$0.75'},
    {range:'$25 ≤ Subtotal < $50', serviceFee:'$1'},
    {range:'$50 ≤ Subtotal < $75', serviceFee:'$1.50'},
    {range:'$75 ≤ Subtotal < $100', serviceFee:'$2'},
    {range:'$100 ≤ Subtotal', serviceFee:'$2.50'}
  ];
  pricesMx: PriceEntry[] = [
    /*
    {range:'Subtotal < $500', serviceFee:'$5'},
    {range:'$500 ≤ Subtotal < $1,000', serviceFee:'$10'},
    {range:'$1,000 ≤ Subtotal', serviceFee:'$15'}
    */
    {range:'Subtotal < $200', serviceFee:'$10'},
    {range:'$200 ≤ Subtotal < $500', serviceFee:'$15'},
    {range:'$500 ≤ Subtotal < $1,000', serviceFee:'$20'},
    {range:'$1,000 ≤ Subtotal < $1,500', serviceFee:'$30'},
    {range:'$1,500 ≤ Subtotal < $2,000', serviceFee:'$40'},
    {range:'$2,000 ≤ Subtotal', serviceFee:'$50'}
  ];

  constructor(
      public deviceService: DeviceService) {
  }

  public isUs() {
    return this.country == Country.Us;
  }

  public isMexico() {
    return this.country == Country.Mexico;
  }
}
